import { Platform } from './Platform';
import { SupportedCompanies } from './Tags';

/**
 * Get website name based on company
 * @param company
 */
export function getSiteNameByCompany(company: SupportedCompanies | string) {
    switch (company) {
        case 'gamebreaker':
            return 'Gamebreaker';
        default:
            return 'Wooter Apparel';
    }
}

/**
 * Get website name based on platform
 * @param platform
 */
export function getSiteNameByPlatform(platform: Platform) {
    return getSiteNameByCompany(platform.getCompany());
}
